export default {
  title: 'フレーム画像の選択',
  next: '次へ',
  noSelectTip: '必要なフレーム数に達しました。これ以上チェックできません。',
  selected: '選択済み {selectNum}/{total}個',
  submit: '完了',
}
